// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Environment Management Styles - Tailwind CSS */

/* Table Container - All Tailwind classes in components */
.projects-table-container {
  overflow-x: auto;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.projects-table {
  width: 100%;
  border-collapse: collapse;
}

.projects-table thead {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}

.projects-table thead th {
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
  white-space: nowrap;
}

.projects-table tbody tr.table-row {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 150ms ease;
}

.projects-table tbody tr.table-row:hover {
  background-color: #f9fafb;
}

.projects-table tbody td.table-cell {
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  color: #111827;
}

/* Action Buttons */
.action-btn-container {
  display: inline-flex;
  align-items: center;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  color: #9ca3af;
  border-radius: 0.375rem;
  transition: all 200ms ease;
  cursor: pointer;
  border: none;
  background: transparent;
}

.action-btn:hover {
  color: #4b5563;
  background-color: #f3f4f6;
}

/* Dropdown Menu Styles */
.action-dropdown {
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  min-width: 200px;
  z-index: 1000;
}

.action-dropdown-divider {
  border-top: 1px solid #e5e7eb;
  margin: 0.25rem 0;
}

.action-dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  color: #374151;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 150ms ease;
}

.action-dropdown-item:hover {
  background-color: #f3f4f6;
}

.action-dropdown-item:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-dropdown-item:disabled:hover {
  background-color: transparent;
}

.dropdown-item-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.action-dropdown-item.text-red-600 {
  color: #dc2626;
}

.action-dropdown-item.text-red-600:hover {
  background-color: #fee2e2;
}

.action-dropdown-item.text-green-600 {
  color: #16a34a;
}

.action-dropdown-item.text-green-600:hover {
  background-color: #dcfce7;
}

/* Animation for dropdown */
.action-dropdown {
  animation: slideDown 0.15s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Submenu Arrow Animation */
.submenu-arrow {
  transition: transform 200ms ease;
}

.submenu-arrow.open {
  transform: rotate(90deg);
}

/* Responsive Design */
@media (max-width: 768px) {
  .projects-table {
    font-size: 0.875rem;
  }

  .projects-table thead th,
  .projects-table tbody td.table-cell {
    padding: 0.5rem;
  }

  .action-btn {
    width: 2rem;
    height: 2rem;
  }
}


/* CONFIGURE · Environments (list + form) */

/* ── List ─────────────────────────────────────────────── */
.rt-env-count {
  margin-left: auto;
  font-size: var(--text-sm, 13px);
  color: var(--text-secondary);
  white-space: nowrap;
}

.rt-env-empty {
  border: 1px dashed var(--border);
  border-radius: 12px;
  background: var(--surface);
}

.rt-env-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.rt-env-cell__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: var(--primary-muted, color-mix(in srgb, var(--primary) 12%, transparent));
  color: var(--primary);
}

.rt-env-cell__text {
  min-width: 0;
}

.rt-env-cell__name {
  font-weight: 600;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 320px;
}

.rt-env-cell__desc {
  margin-top: 2px;
  font-size: 12px;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 320px;
}

.rt-env-url {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.rt-env-url__text {
  min-width: 0;
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
  font-size: 12.5px;
}

.rt-env-url__host {
  color: var(--text-primary);
}

.rt-env-url__path {
  color: var(--text-muted, var(--text-secondary));
}

.rt-env-url__btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  color: var(--text-muted, var(--text-secondary));
  cursor: pointer;
  opacity: 0;
  transition: opacity 120ms ease, background 120ms ease, color 120ms ease;
}

.rt-data-table tr:hover .rt-env-url__btn,
.rt-env-url__btn:focus-visible {
  opacity: 1;
}

.rt-env-url__btn:hover {
  background: var(--surface-hover);
  border-color: var(--border);
  color: var(--primary);
}

@media (hover: none) {
  .rt-env-url__btn {
    opacity: 1;
  }
}

/* ── Form ─────────────────────────────────────────────── */
.rt-env-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 16px;
  align-items: start;
}

@media (max-width: 960px) {
  .rt-env-form {
    grid-template-columns: minmax(0, 1fr);
  }
}

.rt-env-form__main {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
}

.rt-env-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface);
  padding: 18px 20px 20px;
}

.rt-env-card--muted {
  background: var(--surface-hover);
}

.rt-env-card__header {
  margin-bottom: 16px;
}

.rt-env-card__title {
  margin: 0;
  font-size: 14px;
  font-weight: 650;
  color: var(--text-primary);
}

.rt-env-card__subtitle {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: var(--text-secondary);
}

.rt-env-field + .rt-env-field {
  margin-top: 16px;
}

.rt-env-field__label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.rt-env-field__label {
  display: inline-block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}

.rt-env-field__req {
  color: var(--danger);
}

.rt-env-field__counter {
  font-size: 11.5px;
  color: var(--text-muted, var(--text-secondary));
  font-variant-numeric: tabular-nums;
}

.rt-env-input {
  display: block;
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid var(--input-border, var(--border));
  border-radius: 8px;
  background: var(--input-background, var(--surface));
  color: var(--text-primary);
  font: inherit;
  font-size: 13.5px;
  transition: border-color 120ms ease, box-shadow 120ms ease;
  box-sizing: border-box;
}

.rt-env-input::placeholder {
  color: var(--text-muted, var(--text-secondary));
}

.rt-env-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: var(--shadow-focus, 0 0 0 3px color-mix(in srgb, var(--primary) 25%, transparent));
}

.rt-env-input--textarea {
  height: auto;
  min-height: 84px;
  padding: 10px 12px;
  line-height: 1.45;
  resize: vertical;
}

.rt-env-input.is-invalid {
  border-color: var(--danger);
}

.rt-env-input.is-valid {
  border-color: var(--success);
}

.rt-env-url-input {
  display: flex;
  gap: 8px;
}

.rt-env-url-input .rt-env-input {
  flex: 1 1 auto;
  min-width: 0;
}

.rt-env-url-input .rt-btn {
  flex: 0 0 auto;
  height: 38px;
  text-decoration: none;
}

.rt-env-url-input .rt-btn.is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: auto;
}

.rt-env-field__hint,
.rt-env-field__error,
.rt-env-field__status {
  margin: 6px 0 0;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.rt-env-field__hint {
  color: var(--text-muted, var(--text-secondary));
}

.rt-env-field__error,
.rt-env-field__status--fail {
  color: var(--danger);
}

.rt-env-field__status--ok {
  color: var(--success);
}

.rt-env-field__status--checking {
  color: var(--text-secondary);
}

.rt-env-spin {
  animation: rt-env-spin 0.9s linear infinite;
}

@keyframes rt-env-spin {
  to {
    transform: rotate(360deg);
  }
}

.rt-env-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.rt-env-tips {
  margin: 10px 0 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 12.5px;
  line-height: 1.5;
  color: var(--text-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/styles/environment.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,yDAAyD;AACzD;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;EACf,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;EAC/C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,4BAA4B;AAC5B;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;;AAGA,2CAA2C;;AAE3C,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qFAAqF;EACrF,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6EAA6E;EAC7E,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,uBAAuB;EACvB,+CAA+C;EAC/C,eAAe;EACf,UAAU;EACV,uEAAuE;AACzE;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,oDAAoD;EACpD,kBAAkB;EAClB,mDAAmD;EACnD,0BAA0B;EAC1B,aAAa;EACb,iBAAiB;EACjB,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8FAA8F;AAChG;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;AAC9B","sourcesContent":["/* Environment Management Styles - Tailwind CSS */\n\n/* Table Container - All Tailwind classes in components */\n.projects-table-container {\n  overflow-x: auto;\n  background-color: white;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.projects-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.projects-table thead {\n  background-color: #f9fafb;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.projects-table thead th {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #374151;\n  white-space: nowrap;\n}\n\n.projects-table tbody tr.table-row {\n  border-bottom: 1px solid #e5e7eb;\n  transition: background-color 150ms ease;\n}\n\n.projects-table tbody tr.table-row:hover {\n  background-color: #f9fafb;\n}\n\n.projects-table tbody td.table-cell {\n  padding: 0.75rem 1rem;\n  font-size: 0.875rem;\n  color: #111827;\n}\n\n/* Action Buttons */\n.action-btn-container {\n  display: inline-flex;\n  align-items: center;\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  height: 2rem;\n  color: #9ca3af;\n  border-radius: 0.375rem;\n  transition: all 200ms ease;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n}\n\n.action-btn:hover {\n  color: #4b5563;\n  background-color: #f3f4f6;\n}\n\n/* Dropdown Menu Styles */\n.action-dropdown {\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);\n  min-width: 200px;\n  z-index: 1000;\n}\n\n.action-dropdown-divider {\n  border-top: 1px solid #e5e7eb;\n  margin: 0.25rem 0;\n}\n\n.action-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.875rem;\n  color: #374151;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 150ms ease;\n}\n\n.action-dropdown-item:hover {\n  background-color: #f3f4f6;\n}\n\n.action-dropdown-item:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.action-dropdown-item:disabled:hover {\n  background-color: transparent;\n}\n\n.dropdown-item-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.action-dropdown-item.text-red-600 {\n  color: #dc2626;\n}\n\n.action-dropdown-item.text-red-600:hover {\n  background-color: #fee2e2;\n}\n\n.action-dropdown-item.text-green-600 {\n  color: #16a34a;\n}\n\n.action-dropdown-item.text-green-600:hover {\n  background-color: #dcfce7;\n}\n\n/* Animation for dropdown */\n.action-dropdown {\n  animation: slideDown 0.15s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-5px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Submenu Arrow Animation */\n.submenu-arrow {\n  transition: transform 200ms ease;\n}\n\n.submenu-arrow.open {\n  transform: rotate(90deg);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .projects-table {\n    font-size: 0.875rem;\n  }\n\n  .projects-table thead th,\n  .projects-table tbody td.table-cell {\n    padding: 0.5rem;\n  }\n\n  .action-btn {\n    width: 2rem;\n    height: 2rem;\n  }\n}\n\n\n/* CONFIGURE · Environments (list + form) */\n\n/* ── List ─────────────────────────────────────────────── */\n.rt-env-count {\n  margin-left: auto;\n  font-size: var(--text-sm, 13px);\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n\n.rt-env-empty {\n  border: 1px dashed var(--border);\n  border-radius: 12px;\n  background: var(--surface);\n}\n\n.rt-env-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.rt-env-cell__icon {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  background: var(--primary-muted, color-mix(in srgb, var(--primary) 12%, transparent));\n  color: var(--primary);\n}\n\n.rt-env-cell__text {\n  min-width: 0;\n}\n\n.rt-env-cell__name {\n  font-weight: 600;\n  color: var(--text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 320px;\n}\n\n.rt-env-cell__desc {\n  margin-top: 2px;\n  font-size: 12px;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 320px;\n}\n\n.rt-env-url {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.rt-env-url__text {\n  min-width: 0;\n  max-width: 420px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);\n  font-size: 12.5px;\n}\n\n.rt-env-url__host {\n  color: var(--text-primary);\n}\n\n.rt-env-url__path {\n  color: var(--text-muted, var(--text-secondary));\n}\n\n.rt-env-url__btn {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--text-muted, var(--text-secondary));\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity 120ms ease, background 120ms ease, color 120ms ease;\n}\n\n.rt-data-table tr:hover .rt-env-url__btn,\n.rt-env-url__btn:focus-visible {\n  opacity: 1;\n}\n\n.rt-env-url__btn:hover {\n  background: var(--surface-hover);\n  border-color: var(--border);\n  color: var(--primary);\n}\n\n@media (hover: none) {\n  .rt-env-url__btn {\n    opacity: 1;\n  }\n}\n\n/* ── Form ─────────────────────────────────────────────── */\n.rt-env-form {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 280px;\n  gap: 16px;\n  align-items: start;\n}\n\n@media (max-width: 960px) {\n  .rt-env-form {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.rt-env-form__main {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  min-width: 0;\n}\n\n.rt-env-card {\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  background: var(--surface);\n  padding: 18px 20px 20px;\n}\n\n.rt-env-card--muted {\n  background: var(--surface-hover);\n}\n\n.rt-env-card__header {\n  margin-bottom: 16px;\n}\n\n.rt-env-card__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 650;\n  color: var(--text-primary);\n}\n\n.rt-env-card__subtitle {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: var(--text-secondary);\n}\n\n.rt-env-field + .rt-env-field {\n  margin-top: 16px;\n}\n\n.rt-env-field__label-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.rt-env-field__label {\n  display: inline-block;\n  margin-bottom: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rt-env-field__req {\n  color: var(--danger);\n}\n\n.rt-env-field__counter {\n  font-size: 11.5px;\n  color: var(--text-muted, var(--text-secondary));\n  font-variant-numeric: tabular-nums;\n}\n\n.rt-env-input {\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 0 12px;\n  border: 1px solid var(--input-border, var(--border));\n  border-radius: 8px;\n  background: var(--input-background, var(--surface));\n  color: var(--text-primary);\n  font: inherit;\n  font-size: 13.5px;\n  transition: border-color 120ms ease, box-shadow 120ms ease;\n  box-sizing: border-box;\n}\n\n.rt-env-input::placeholder {\n  color: var(--text-muted, var(--text-secondary));\n}\n\n.rt-env-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus, 0 0 0 3px color-mix(in srgb, var(--primary) 25%, transparent));\n}\n\n.rt-env-input--textarea {\n  height: auto;\n  min-height: 84px;\n  padding: 10px 12px;\n  line-height: 1.45;\n  resize: vertical;\n}\n\n.rt-env-input.is-invalid {\n  border-color: var(--danger);\n}\n\n.rt-env-input.is-valid {\n  border-color: var(--success);\n}\n\n.rt-env-url-input {\n  display: flex;\n  gap: 8px;\n}\n\n.rt-env-url-input .rt-env-input {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rt-env-url-input .rt-btn {\n  flex: 0 0 auto;\n  height: 38px;\n  text-decoration: none;\n}\n\n.rt-env-url-input .rt-btn.is-disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: auto;\n}\n\n.rt-env-field__hint,\n.rt-env-field__error,\n.rt-env-field__status {\n  margin: 6px 0 0;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.rt-env-field__hint {\n  color: var(--text-muted, var(--text-secondary));\n}\n\n.rt-env-field__error,\n.rt-env-field__status--fail {\n  color: var(--danger);\n}\n\n.rt-env-field__status--ok {\n  color: var(--success);\n}\n\n.rt-env-field__status--checking {\n  color: var(--text-secondary);\n}\n\n.rt-env-spin {\n  animation: rt-env-spin 0.9s linear infinite;\n}\n\n@keyframes rt-env-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rt-env-form__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.rt-env-tips {\n  margin: 10px 0 0;\n  padding-left: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
